import React from 'react';
import { Link } from 'react-router-dom';
import { MdArrowBack } from 'react-icons/md';

// The way back out, one step up: from a mode to the ResearchOS hub, from the hub to the
// portal. Nothing more — an earlier version also drew a ResearchOS wordmark above each
// mode's own heading, which put the same word on screen twice.

export default function ResearchCrumb({ mode }) {
  // Inside a mode, the page's own heading already says which one, so a wordmark above it
  // was the same word twice. What is actually needed here is the way back out.
  const up = mode ? { to: '/research', label: 'ResearchOS' } : { to: '/', label: 'All areas' };
  return (
    <div className="mb-4 flex items-center gap-2 text-[11px]">
      <Link
        to={up.to}
        className="flex shrink-0 items-center gap-1 text-gray-400 transition-colors hover:text-brand-gold dark:text-gray-500"
      >
        <MdArrowBack size={14} />
        {up.label}
      </Link>
    </div>
  );
}
